import { render, staticRenderFns } from "./ReportMenuVersion.vue?vue&type=template&id=8cbd6806&"
import script from "./ReportMenuVersion.vue?vue&type=script&lang=js&"
export * from "./ReportMenuVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports